import { useEffect } from 'react';
import Header from '../../components/feature/Header';
import FooterSection from '../home/components/FooterSection';

const SITE_URL = import.meta.env.VITE_SITE_URL ?? 'https://example.com';

const schemaOrg = {
  '@context': 'https://schema.org',
  '@type': 'CollectionPage',
  '@id': `${SITE_URL}/news#webpage`,
  url: `${SITE_URL}/news`,
  name: 'お知らせ｜株式会社Y\'s STUDIO',
  description: '株式会社Y\'s STUDIOの最新ニュース・サービス情報をお届けします。神戸のWeb制作・業務自動化・SNS自動投稿に関するお知らせ一覧。',
  inLanguage: 'ja',
  isPartOf: {
    '@type': 'WebSite',
    '@id': `${SITE_URL}/#website`,
    url: `${SITE_URL}/`,
    name: '株式会社Y\'s STUDIO',
  },
};

export default function NewsPage() {
  useEffect(() => {
    const id = 'schema-news';
    let el = document.getElementById(id) as HTMLScriptElement | null;
    if (!el) {
      el = document.createElement('script');
      el.id = id;
      el.type = 'application/ld+json';
      document.head.appendChild(el);
    }
    el.textContent = JSON.stringify(schemaOrg);
    return () => {
      document.getElementById(id)?.remove();
    };
  }, []);

  const allNews = [
    {
      date: '2025.10.01',
      category: 'サービス',
      title: 'AIを活用したLP制作サービスを導入(参考のため、本サイトはAIを活用して作成しました)',
      isNew: true,
      description: 'AI技術を活用した最新のランディングページ制作サービスを開始いたしました。効率的で高品質なLP制作が可能になります。'
    },
    {
      date: '2025.09.01',
      category: 'サービス',
      title: 'インスタグラム等のSNS自動投稿サービスを開始いたしました',
      isNew: false,
      description: 'Instagram、Facebook、Twitterなど主要SNSへの自動投稿サービスを開始。効率的なSNS運用をサポートいたします。'
    },
    {
      date: '2025.01.08',
      category: 'お知らせ',
      title: '株式会社としての登録が完了し法人番号を取得いたしました',
      isNew: false,
      description: '法人登記が完了し、正式に株式会社として事業を展開することとなりました。今後ともよろしくお願いいたします。'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      <main className="pt-24 pb-16">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="mb-12">
            <h1 className="text-4xl font-bold text-gray-900 mb-4">
              お知らせ
            </h1>
            <p className="text-gray-600">
              最新のニュースやサービス情報をお届けします
            </p>
          </div>

          <div className="space-y-6">
            {allNews.map((item, index) => (
              <article 
                key={index} 
                className="bg-white border border-gray-200 rounded-lg p-6 hover:shadow-lg transition-shadow cursor-pointer"
              >
                <div className="flex flex-col sm:flex-row sm:items-start gap-4 mb-4">
                  <div className="flex items-center gap-3 sm:flex-shrink-0">
                    <time className="text-sm text-gray-500 font-medium whitespace-nowrap">
                      {item.date}
                    </time>
                    
                    <span className={`inline-block px-3 py-1 rounded-full text-xs font-semibold whitespace-nowrap ${
                      item.category === 'サービス' ? 'bg-blue-100 text-blue-700' :
                      item.category === 'アップデート' ? 'bg-orange-100 text-orange-700' :
                      'bg-gray-100 text-gray-700'
                    }`}>
                      {item.category}
                    </span>

                    {item.isNew && (
                      <span className="bg-red-500 text-white text-xs px-2 py-1 rounded-full font-semibold whitespace-nowrap">
                        NEW
                      </span>
                    )}
                  </div>
                </div>

                <h2 className="text-xl font-bold text-gray-900 mb-3 hover:text-orange-600 transition-colors">
                  {item.title}
                </h2>

                <p className="text-gray-600 leading-relaxed mb-4">
                  {item.description}
                </p>

                <div className="flex items-center text-orange-600 font-semibold text-sm">
                  詳しく見る
                  <i className="ri-arrow-right-line ml-1"></i>
                </div>
              </article>
            ))}
          </div>
        </div>
      </main>

      <FooterSection />
    </div>
  );
}